import { Space } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { ProjectDetailTabKeys } from 'api/project';
import { Loading } from 'components/atoms/loading';
import {
  getProjectConversationPageUrl,
  getProjectFilesUrl,
  getProjectFormResponseUrl,
  getProjectOverviewUrl,
  getProjectPlanUrl,
  getProjectStatusUpdatesUrl,
  getProjectTasksUrl,
} from 'utils/urls';
import { Loader, LoadingMessage } from './styled';

export const useConversationIdFromUrl = (): string | undefined => {
  const location = useLocation();

  const pathname = location?.pathname;

  if (!pathname) {
    return undefined;
  }
  const search = location?.search;
  const hash = location?.hash;

  return pathname.includes('/chat/')
    ? pathname.replace(/.*\//, '')?.replace(search, '')?.replace(hash, '')
    : undefined;
};

export const getIcon = (IconEl) => {
  return IconEl ? <IconEl /> : null;
};

export const InviteTriggerLoader = () => {
  return (
    <Loader>
      <Space size={8}>
        <div>
          <Loading size="small" />
        </div>
        <LoadingMessage>
          <FormattedMessage id="loading" />
        </LoadingMessage>
      </Space>
    </Loader>
  );
};

export const tabRoutePathMap = {
  [ProjectDetailTabKeys.Overview]: getProjectOverviewUrl,
  [ProjectDetailTabKeys.Plan]: getProjectPlanUrl,
  [ProjectDetailTabKeys.Chat]: getProjectConversationPageUrl,
  [ProjectDetailTabKeys.StatusUpdate]: getProjectStatusUpdatesUrl,
  [ProjectDetailTabKeys.TaskList]: getProjectTasksUrl,
  [ProjectDetailTabKeys.FormResponses]: getProjectFormResponseUrl,
  [ProjectDetailTabKeys.Files]: getProjectFilesUrl,
};
